import { gql, useMutation } from '@apollo/client';

const DELETE_FSP_MUTATION = gql`
  mutation ($id: ID!) {
    deleteFileServiceProvider(id: $id)
  }
`;

export const useDeleteFileServiceProvider = () => {
  return useMutation(DELETE_FSP_MUTATION);
};
